<template>
  <CSidebar
    color-scheme="light"
    fixed
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <div class="m-2 float-right">
      <!-- <label class="float-right ml-1 text-black" v-on:click="SignOut()"
        >Logout</label
      > -->
      <!-- <CIcon
        name="cil-lock-locked text-black"
        v-on:click="SignOut()"
        class="float-left mr-0"
        title="Logout"
      /> -->
    </div>
    <CSidebarBrand class="d-md-down-none" to="/">
      <img
        src="../assets/img/pickiddologolargesize.png"
        name="logo"
        size="custom-size"
        :height="35"
        viewBox="0 0 556 134"
      />
    </CSidebarBrand>
      <CRenderFunction flat :content-to-render="selectedNavigationMenu" />

    <!-- <CRenderFunction flat :content-to-render="$options.nav" /> -->
    <!-- <div
      class="text-white"
      :style="{ backgroundImage: `url(${backgroundUrl})` }"
      style="border-radius: 20px; background-size: cover; margin-bottom: auto;padding:10px;"
    >
      <span class="p-2">
        <p class="ml-4">Need help?</p>
        <p class="ml-4">Please check our help manual</p>
        <CButton color="light" class="ml-4">Manual</CButton>
      </span>
    </div> -->

    

    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import nav from "./_nav";
import navTutor from "./_navTutor";
import backgroundUrl from "../assets/img/img.png";

export default {
  name: "TheSidebar",
  nav,
  navTutor,
  data() {
    return {
      backgroundUrl,
      selectedNavigationMenu: [],
    };
  },
  mounted() {
    this.GetProfilePicture();
  },
  computed: {
    show() {
      return this.$store.state.sidebarShow;
    },
    minimize() {
      return this.$store.state.sidebarMinimize;
    },
    SignOut: function () {
      return this.$API
        .get(this.$SignOut, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.$router.push("/Login");
          }
        });
    },
  },
  methods: {
     GetProfilePicture() {
      this.$API
        .get(this.$ViewProfilePictureAdmin, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.user = response.data;
             this.getNavigationMenu(this.user.Id);
          }
        });
    },
     getNavigationMenu(Id) {
      switch (Id) {
        case 1020:
          this.selectedNavigationMenu = this.$options.nav;
          break;
        case 2075:
          this.selectedNavigationMenu = this.$options.nav;
          break;
        default:
          this.selectedNavigationMenu = this.$options.navTutor;
          break;
      }
    },
  },
};
</script>
